export function fillWithZeros(length, string) {
  const missingZerosAmount = length - string.length

  Array(missingZerosAmount)
    .fill(0)
    .forEach(() => {
      string = "0" + string
    })

  return string
}

export default fillWithZeros
